var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.features.length > 0
    ? _c(
        "section",
        { staticClass: "icon-group-section" },
        [
          _c(
            "b-container",
            [
              _c(
                "b-row",
                { staticClass: "justify-content-md-center" },
                [
                  _c("b-col", [
                    _c(
                      "div",
                      {
                        staticClass: "icon-group",
                        class: `${_vm.featureGridStyle} ${_vm.selectedGridGap}`,
                      },
                      _vm._l(_vm.features, function (feature, index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "grid-item" },
                          [
                            _vm.isFeatureLink(feature)
                              ? [
                                  _c(
                                    _vm.linkComponent(feature),
                                    {
                                      tag: "component",
                                      staticClass: "icon-cta-link",
                                      attrs: {
                                        to: {
                                          path: _vm.getFeatureButton(feature)
                                            .url,
                                        },
                                        href: _vm.$options.filters.toUrl(
                                          _vm.getFeatureButton(feature).url
                                        ),
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "icon-cta-item",
                                          class: `${_vm.selectedctaItemStyle} ${_vm.selectedctaItemDirection}`,
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "icon-cta-item-content",
                                            },
                                            [
                                              _c(
                                                _vm.getLayoutComponent,
                                                _vm._b(
                                                  {
                                                    tag: "component",
                                                    attrs: {
                                                      feature: feature,
                                                      constructed:
                                                        _vm.constructed,
                                                    },
                                                  },
                                                  "component",
                                                  _vm.getLayoutProps,
                                                  false
                                                )
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              : [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "icon-cta-item",
                                      class: `${_vm.selectedctaItemStyle} ${_vm.selectedctaItemDirection}`,
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "icon-cta-item-content",
                                        },
                                        [
                                          _c(
                                            _vm.getLayoutComponent,
                                            _vm._b(
                                              {
                                                tag: "component",
                                                attrs: {
                                                  feature: feature,
                                                  constructed: _vm.constructed,
                                                },
                                              },
                                              "component",
                                              _vm.getLayoutProps,
                                              false
                                            )
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                ],
                          ],
                          2
                        )
                      }),
                      0
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }